import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const OurExpertise = () => {
  const navigate = useNavigate();
  const expertise = [
    {
      title: 'ERP Software Development',
      category: 'Enterprise Solution',
      subject: 'Inquiry about ERP Software',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    },
    {
      title: 'Web Application Development',
      category: 'Digital Transformation',
      subject: 'Inquiry about Web Applications',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    },
    {
      title: 'Mobile App Development',
      category: 'App Ecosystem',
      subject: 'Inquiry about Mobile Apps',
      image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80',
    },
    {
      title: 'E-commerce & Marketplace Solutions',
      category: 'Quick Commerce',
      subject: 'Inquiry about E-commerce',
      image: 'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?w=800&q=80',
    },
    {
      title: 'API Integration & Automation',
      category: 'System Connectivity',
      subject: 'Inquiry about API Integration',
      image: '/assets/img/api_inter.png',
    },
    {
      title: 'Payment Gateway & UPI Integration',
      category: 'Financial Tech',
      subject: 'Inquiry about Payment Gateway',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80',
    },
    {
      title: 'CRM & Business Management Systems',
      category: 'Workflow Optimization',
      subject: 'Inquiry about CRM Systems',
      image: '/assets/img/crm.jpg',
    },
    {
      title: 'Cloud-Based Solutions',
      category: 'Cloud Infrastructure',
      subject: 'Inquiry about Cloud Solutions',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
    },
    {
      title: 'Business Intelligence & Reporting',
      category: 'Data Analytics',
      subject: 'Inquiry about Business Intelligence',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="our-expertise" className="py-20 bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-dark mb-4">
            Our <span className="text-primary">Expertise</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Showcase of successful projects delivered for our clients across various industries
          </p>
        </motion.div>

        {/* Portfolio Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {expertise.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -10 }}
              onClick={() => navigate(`/contact?subject=${encodeURIComponent(item.subject)}`)}
              className="group relative overflow-hidden rounded-xl shadow-soft hover:shadow-soft-lg transition-all duration-300 cursor-pointer h-64 border border-gray-100"
            >
              {/* Background Image or Gradient */}
              {item.image ? (
                <motion.img
                  src={item.image}
                  alt={item.title}
                  whileHover={{ scale: 1.1 }}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-300"
                />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-secondary/10" />
              )}

              {/* Overlay on Hover */}
              <motion.div
                initial={{ opacity: 0, backdropFilter: 'blur(0px)' }}
                whileHover={{ opacity: 1, backdropFilter: 'blur(4px)' }}
                className="absolute inset-0 bg-black/40 flex items-center justify-center"
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileHover={{ opacity: 1, scale: 1 }}
                  className="text-center text-white space-y-2"
                >
                  <p className="text-sm font-semibold text-gray-200">
                    {item.category}
                  </p>
                  <p className="text-lg font-bold px-4">{item.title}</p>
                  <motion.button
                    whileHover={{ gap: '8px' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/contact?subject=${encodeURIComponent(item.subject)}`);
                    }}
                    className="inline-flex items-center gap-2 mt-4 px-4 py-2 bg-primary hover:bg-secondary rounded-lg text-white font-semibold transition-colors"
                  >
                    Enquire Now →
                  </motion.button>
                </motion.div>
              </motion.div>

              {/* Content Display */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/50 to-transparent text-white group-hover:opacity-0 transition-opacity duration-300">
                <h3 className="text-xl font-bold">{item.title}</h3>
                <p className="text-sm text-gray-200">{item.category}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default OurExpertise;
